import { render, staticRenderFns } from "./DescuentoDetalleComponent.vue?vue&type=template&id=334c6022"
import script from "./DescuentoDetalleComponent.vue?vue&type=script&lang=js"
export * from "./DescuentoDetalleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports